import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2e7d32',
      light: '#60ad5e',
      dark: '#005005',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#a5d6a7',
      light: '#d7ffd9',
      dark: '#75a478',
      contrastText: '#0b3d0b'
    },
    background: {
      default: '#f3f8f3',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f2d0f',
      secondary: '#2f4f2f',
    },
    success: { main: '#43a047' },
    info: { main: '#66bb6a' },
    grey: {
      100: '#edf7ed',
      200: '#d7ead7',
      300: '#b6d2b6',
      800: '#1b3b1b',
    },
  },
  typography: {
    fontFamily: 'Inter, "Noto Sans Devanagari", "Hind", "Mangal", Arial, sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: '2.4rem',
      letterSpacing: '-0.01em'
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.6rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.95rem',
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          border: 'none',
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'hidden',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 30px rgba(46, 125, 50, 0.15)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(8px)'
        }
      }
    }
  },
});

export default theme;






